var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBody5D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "headtype5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M264.1,244.7c1,4.8,1.6,9.6,2.1,15.2C265.8,254.8,265.2,249.7,264.1,244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M473.8,253.9c-0.5-7-4-18.8-10.2-21.2c-2.2-0.9-4.4-0.2-6.4,1.2c0,0.4-0.1,0.8-0.1,1.2 c-7.9,21.6-5.2,47.4-4.6,69.5c0.6,0.7,1.3,1.2,2.1,1.5c5.4,1.7,12-6.4,13.8-11.5C473,281.3,474.9,270.2,473.8,253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M266.2,259.9c-0.5-5.6-1.1-10.4-2.1-15.2c-0.7-3.3-1.6-6.6-2.8-9.8l0,0c-2.4-2.2-5.2-3.4-8.2-2.3 c-6.4,2.4-10.1,14.2-10.6,21.2c-1.2,16.4,0.8,27.5,5.6,40.6c1.9,5.1,8.8,13.1,14.4,11.5c0.8-0.2,2-1,2.7-1.6 C265.7,290.2,267.2,274.9,266.2,259.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#784331",
    d: "M600.2,606.7c-1-8.2-2.2-16.3-3.4-24.5c6.1-0.4,3.8-3.7,2.7-8.5c-1.2-5.4-2.6-10.7-4.2-16 c-3-10-6.3-19.5-10.4-29c-8.7-20.4-25.7-29.1-45.2-36.9c-29.1-11.6-61.3-15.4-88.7-31.4c-14.4-8.4-22.6-21.2-25.8-37.5 c-0.1-0.7-0.3-1.4-0.4-2.1c-0.1-0.4-0.1-0.7-0.2-1.1s-0.2-0.9-0.2-1.4c-1.3-7.8-2.3-16.9-3-25.7c0-0.2,0-0.5-0.1-0.7 c-0.1-0.7-0.1-1.4-0.1-2.1c0-0.4,0-0.7-0.1-1.1c0-0.6-0.1-1.3-0.1-1.9c0-0.4-0.1-0.9-0.1-1.3c0-0.6-0.1-1.1-0.1-1.7 c0-0.5,0-1-0.1-1.5c0-0.5,0-1-0.1-1.5c0-0.5,0-1.1-0.1-1.6c0-0.4,0-0.8,0-1.3c0-0.3,0-0.5,0-0.8c-7.2,7.9-14.6,14.8-20.9,20.5 s-12,8.9-17,10.7c-3.9,1.4-18.6,1.2-23.8,1c-5.1,0.2-13.8,0.1-18.8-0.8c-8-1.3-13.8-3.5-19.5-8.6c-8.1-7.2-17.4-15.6-26.1-25.7 c-0.3,15.2-1.7,34.9-4.4,48.5c-3.3,16.3-11.5,29.1-25.8,37.5c-27.4,16-59.6,19.7-88.7,31.4c-19.5,7.8-35.8,13.2-45.2,36.9 c-3.8,9.7-7.4,19.1-10.4,29c-1.6,5.3-9.5,33.9-10.4,46.4c-0.4,4.9,0,4.3,0.3,4.5c3.9,0.4,9.6-0.7,9.6,0c0,4,0.1,9.7,0.3,14.2 c0.1,1.6,0.1,3.5,0.2,4.9c63.7,57.2,147.9,92.1,240.3,92.1c93.1,0,178-35.4,241.9-93.4C602.4,622.3,600.8,611.4,600.2,606.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4D0000",
    d: "M459.5,293.5c-0.4,0-0.8-0.3-0.9-0.7c-2.6-14.2-3.2-28.2,0.5-41.9c0.1-0.5,1-2.8,1.4-2.6s0.1,1.8-0.1,2.4 c-3.6,13.3-2.2,26.5-0.6,40.8C459.9,292.1,460,293.4,459.5,293.5C459.6,293.5,459.6,293.5,459.5,293.5L459.5,293.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M600.7,580.5c0,0.1-0.1,0.2-0.1,0.2C600.6,580.6,600.7,580.5,600.7,580.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M600.4,580.9L600.4,580.9C600.3,581,600.4,581,600.4,580.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M600.8,579.9c0,0.1,0,0.2-0.1,0.4C600.8,580.2,600.8,580.1,600.8,579.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M119.3,611.3c0-1,0-1.9,0-2.7C119.3,609.4,119.3,610.3,119.3,611.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.3,607.3L109.3,607.3L109.3,607.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M119.4,612.3c0-0.3,0-0.7,0-1C119.4,611.7,119.4,612,119.4,612.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M119.4,615.7c0-0.2,0-0.4,0-0.6C119.4,615.2,119.4,615.5,119.4,615.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M119.4,617.4c0-0.1,0-0.1,0-0.2C119.4,617.3,119.4,617.3,119.4,617.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M119.4,613.9c0-0.3,0-0.5,0-0.8C119.4,613.4,119.4,613.7,119.4,613.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.3,607.7C109.3,607.7,109.3,607.6,109.3,607.7C109.3,607.6,109.3,607.7,109.3,607.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.3,607.9L109.3,607.9L109.3,607.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.4,608.3C109.4,608.3,109.4,608.2,109.4,608.3C109.4,608.2,109.4,608.3,109.4,608.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.4,608.1L109.4,608.1L109.4,608.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M600,581.3L600,581.3C599.9,581.4,600,581.4,600,581.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M598.8,581.9c0,0-0.1,0-0.2,0C598.7,581.9,598.7,581.9,598.8,581.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M600.8,579.8c0-0.2,0-0.3,0-0.5C600.9,579.5,600.9,579.7,600.8,579.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M597.9,582.1L597.9,582.1C597.8,582.1,597.8,582.1,597.9,582.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M596.8,582.2c0.7,4.5,1.3,8.9,1.9,13.4C598.1,591.1,597.4,586.7,596.8,582.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M599.5,581.6c-0.1,0-0.1,0-0.2,0.1C599.4,581.7,599.4,581.7,599.5,581.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M109.4,608.3c0.1,0.3,0.2,0.2,0.3,0.3C109.6,608.5,109.5,608.6,109.4,608.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M600.6,580.7c0,0.1-0.1,0.2-0.2,0.2C600.5,580.9,600.5,580.8,600.6,580.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M598.6,581.9c-0.2,0.1-0.5,0.1-0.7,0.2C598.1,582.1,598.4,582,598.6,581.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M600.3,581.1c-0.1,0.1-0.2,0.2-0.3,0.2C600.1,581.2,600.2,581.2,600.3,581.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M600.8,579.3L600.8,579.3L600.8,579.3L600.8,579.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M600.8,579.8L600.8,579.8C600.8,579.9,600.8,579.9,600.8,579.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M599.3,581.7c-0.2,0.1-0.3,0.1-0.6,0.2C599,581.9,599.2,581.8,599.3,581.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M599.9,581.4c-0.1,0.1-0.3,0.2-0.4,0.2C599.6,581.6,599.8,581.5,599.9,581.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M597.8,582.1c-0.3,0-0.6,0.1-1,0.1C597.1,582.2,597.5,582.2,597.8,582.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M598.7,595.7C598.7,595.6,598.7,595.6,598.7,595.7C598.7,595.6,598.7,595.6,598.7,595.7L598.7,595.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M600.7,580.3c0,0.1,0,0.1-0.1,0.2C600.7,580.4,600.7,580.4,600.7,580.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M487.2,600.9c-1.9,0.5-9.6,2-6.3,5.7c1.6,1.8,13.4,0.6,16.5,0.4c15.3-1.1,26.8-2.8,42-4.3 c19.8-2,39.6-4.2,59.4-6.9v-0.1c-0.6-4.5-1.3-8.9-1.9-13.4c0.4,0,0.7-0.1,1-0.1h0.1c0.3,0,0.5-0.1,0.7-0.2c0.1,0,0.1,0,0.2,0 c0.2-0.1,0.4-0.1,0.6-0.2c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.2l0.1-0.1 c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.4V580c0-0.2,0-0.3,0-0.5l0,0 c-31.2,4.5-62.2,10-93,16.8C500.9,597.6,494,598.9,487.2,600.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M119.5,620.7L119.5,620.7c0-1.1-0.1-2.2-0.1-3.3C119.5,618.5,119.5,619.6,119.5,620.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M119.4,615c0-0.4,0-0.7,0-1.1C119.4,614.3,119.4,614.7,119.4,615z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M119.4,617.2c0-0.5,0-1.1,0-1.6C119.4,616.2,119.4,616.7,119.4,617.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M119.4,613.2c0-0.3,0-0.6,0-0.9C119.4,612.6,119.4,612.9,119.4,613.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M109.3,607.6c0-0.1,0-0.2,0-0.3C109.3,607.4,109.3,607.5,109.3,607.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M109.5,604.2c-0.1,1.5-0.2,2.5-0.2,3.1C109.3,606.6,109.4,605.6,109.5,604.2L109.5,604.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M109.3,607.9c0-0.1,0-0.1,0-0.2C109.3,607.8,109.3,607.8,109.3,607.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M109.4,608.1L109.4,608.1C109.4,608,109.4,608,109.4,608.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M109.4,608.3L109.4,608.3L109.4,608.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M109.4,608.2L109.4,608.2L109.4,608.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M119.3,611.3L119.3,611.3L119.3,611.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M213.3,617.3c4-0.4,8-1.1,11.9-2c5-1.2,2.5-4.5-0.9-5.3c-7.7-1.9-15.7-2.7-23.6-3.5 c-32.2-3.2-61.2-2.7-91.2-2.3c-0.1,1.5-0.2,2.5-0.2,3.1c0,0,0,0,0,0.1s0,0.2,0,0.3l0,0c0,0.1,0,0.2,0,0.2l0,0v0.1v0.1 c0,0,0,0,0,0.1v0.1l0,0c0.1,0.3,0.2,0.2,0.3,0.3c3.9,0.4,9.6-0.7,9.6,0c0,0.8,0,1.7,0,2.7c0,0,0,0,0,0.1c0,0.3,0,0.7,0,1 s0,0.6,0,0.9c0,0.2,0,0.5,0,0.8c0,0.4,0,0.7,0,1.1c0,0.2,0,0.4,0,0.6c0,0.5,0,1.1,0,1.6c0,0.1,0,0.1,0,0.2c0,1.1,0,2.2,0.1,3.3 c14.5-0.1,29.1-0.1,43.6-0.5C179.9,619.7,196.6,618.9,213.3,617.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D0000",
    d: "M257.3,293.5c0.4,0,0.8-0.3,0.9-0.7c2.7-14.2,3.3-28.2-0.6-41.9c-0.2-0.5-1.1-2.8-1.5-2.6s-0.1,1.8,0.1,2.4 c3.8,13.3,2.3,26.5,0.6,40.8c-0.1,0.6-0.2,1.9,0.3,2.1C257.2,293.5,257.3,293.5,257.3,293.5L257.3,293.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784331",
    d: "M451.9,185.8c-3.3-17.1-7.5-31.3-16.3-46.1c-16.2-27-48.8-35.2-76.4-36.6l0,0l0,0l0,0l0,0 c-27.6,1.4-60.2,9.5-76.4,36.6c-8.8,14.8-13,29-16.3,46.1c-2.8,14.3-6.6,34.8-5.1,49.2c8.3,22.6,4.3,49.2,3.9,71.9 c3.4,46.7,33.8,74.1,55.3,93.3c5.7,5.1,11.5,7.2,19.5,8.6c4.9,0.8,13.6,0.9,18.8,0.8c5.1,0.2,19.8,0.4,23.8-1c5-1.8,10.7-5,17-10.7 c20.7-18.5,51.6-48.6,53-90.3c-0.4-22.6-3.8-49.9,4.5-72.5C458.6,220.5,454.7,200.1,451.9,185.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#622C17",
    d: "M399.5,397.8c-6.3,5.7-12,8.9-17,10.7c-3.9,1.4-18.6,1.2-23.8,1c-5.1,0.2-13.8,0.1-18.8-0.8 c-8-1.3-13.8-3.5-19.5-8.6c-7.7-6.9-16.5-14.8-24.8-24.2c21.8,43.7,83,65.5,129,44.9c-0.1-0.4-0.1-0.7-0.2-1.1s-0.2-0.9-0.2-1.4 c-2.1-12.5-3.4-28.4-3.8-41C413.3,385.3,405.9,392.1,399.5,397.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody5D);
export default __webpack_public_path__ + "static/media/body_5d.6ff5cf7ee0f422552c6bd019ae9abc5b.svg";
export { ForwardRef as ReactComponent };